<div class="push"></div>
<div class="footer">
  <a href="http://www.smartscaffolder.com"><img src="/assets/img/smart-scaffolder-logo-alt-03.svg" height="22" class="pull-right"></a>
  <span>Client:{{clientVersion}} Server:{{serverVersion}}</span>
</div>
